module.exports = __webpack_public_path__ + "img/use_selected.81343103.svg";